import React, { useEffect, useState, useRef, JSX } from "react";
import { Link } from "react-router-dom";
import "./homePage.css";

import CloudItServices from "../../assets/11.png";
import ItRecruitmentEngineering from "../../assets/22.png";
import AsicFpgaSolutions from "../../assets/33.png";
import FiveGTelecomSolutions from "../../assets/44.png";

type Slide = {
  bg: string;
  title: string;
  subtitle: string;
  cta?: { label: string; to: string };
};

const slides: Slide[] = [
  {
    bg: AsicFpgaSolutions,
    title: "ASIC & FPGA ENGINEERING SOLUTIONS",
    subtitle:
      "End-to-end ASIC and FPGA design, verification, and system integration services tailored for high-performance applications.",
    cta: { label: "VIEW SOLUTIONS", to: "/services/software-service" },
  },
  {
    bg: FiveGTelecomSolutions,
    title: "5G NETWORKING & TELECOMMUNICATION SOLUTIONS",
    subtitle:
      "Designing, deploying, and optimizing next-generation 5G networks for high-speed and low-latency connectivity.",
    cta: { label: "EXPLORE 5G SOLUTIONS", to: "/services/project-service" },
  },
  {
    bg: CloudItServices,
    title: "CLOUD & SAP IT SERVICES",
    subtitle:
      "Delivering scalable cloud solutions and SAP-driven enterprise systems to modernize, integrate, and accelerate your business operations.",
    cta: { label: "ABOUT", to: "/about-us" },
  },
  {
    bg: ItRecruitmentEngineering,
    title: "IT RECRUITMENT & ENGINEERING SERVICES",
    subtitle:
      "Connecting businesses with top-tier IT and engineering talent across ASIC, FPGA, and advanced technology domains.",
    cta: { label: "CURRENT OPENINGS", to: "/careers" },
  },
];

export default function HomePage(): JSX.Element {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef<number | null>(null);
  const len = slides.length;
  const slide = slides[index];

  /* PRELOAD IMAGES */
  useEffect(() => {
    slides.forEach((s) => {
      const img = new Image();
      img.src = s.bg;
    });
  }, []);

  /* AUTO SLIDE */
  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setIndex((i) => (i + 1) % len);
    }, 10000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [len]);

  return (
    <main>
      <header className="hero" role="banner">
        <div className="hero__stage">
          <div
            className="hero__bg"
            style={{ backgroundImage: `url(${slide.bg})` }}
          />

          <div className="hero__overlay" />

          <div className="hero__content-grid">
            <section className="hero__content">
              <span className="hero__chip">
                Engineering • Embedded • IoT
              </span>

              <h1 className="hero__title">{slide.title}</h1>
              <p className="hero__subtitle">{slide.subtitle}</p>

              <div className="hero__actions">
                {slide.cta && (
                  <Link
                    className="btn btn--primary"
                    to={slide.cta.to}
                  >
                    {slide.cta.label}
                  </Link>
                )}

                <Link className="btn btn--ghost" to="/contact-us">
                  Talk to us
                </Link>
              </div>
            </section>
          </div>

          {/* DOT NAV */}
          <div className="hero__nav">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === index ? "dot--active" : ""}`}
                onClick={() => setIndex(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </header>
    </main>
  );
}
